module.exports = "<kd-repeater list=\"$ctrl.data\">\r\n  <facturacion-facturas-ingreso-masivo-lista-item ng-repeat=\"item in $items track by $index\" data=\"item\"></facturacion-facturas-ingreso-masivo-lista-item>\r\n</kd-repeater>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/facturacion/facturas/components/ingreso/masivo/lista/template.html
// module id = 2681
// module chunks = 0